<template>
  <div class="subjectInfo">
    <div class="subjectHead">
      <div class="subjectHeadTitle">
        <img src="./../../../../assets/img/music.png" alt="" />
        <div>
          <p>{{ rowInfo.subjectName }}</p>
          <p>报考级别数量：{{ rowInfo.levelNum }}</p>
        </div>
        <div>
          <el-button size="mini" :disabled="rowInfo.subjectStatus == 102" @click="updateInfo">修改</el-button>
        </div>
      </div>
      <div class="removeBox" v-if="rowInfo.subjectStatus == 0" @click="removeInfo">
        <i class="el-icon-delete"></i>
      </div>
    </div>
    <div class="subjectTableBox">
      <table class="bgTable">
        <tr>
          <td class="bg">报考级别</td>
          <td class="bg">考级费用（元）</td>
          <td class="bg">是否需要审核</td>
        </tr>
        <tr v-for="(item, index) in rowInfo.subjectLevelDTOs" :key="index">
          <td>{{ item.subjectLevel | filterLv }}</td>
          <td>{{ item.subjectAmount }}</td>
          <td>{{ item.needVerify ? '需要审核' : '不需要审核' }}</td>
        </tr>
        <tr v-for="item in getTrList" :key="item">
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["rowInfo"],
  computed: {
    getTrList() {
      let length = this.rowInfo.subjectLevelDTOs.length || 0;
      let id = this.rowInfo.subjectId;
      let list = [];
      for (let index = 0; index < 5 - length; index++) {
        list.push(id + index)
      }
      return list;
    }
  },
  filters: {
    filterLv(num) {
      let lvList = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九", '十', "初", "中", "高"]
      return lvList[num] + '级'
    }
  },
  methods: {
    updateInfo() {
      this.$emit('operInfo', 2, this.rowInfo)//修改
    },
    removeInfo() {
      this.$dailog({
        title: "删除",
        context: "是否删除?",
        callbackFun: () => {
          this.$emit('removeInfo', this.rowInfo.subjectId)
        },
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.subjectInfo {
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 350px;
  height: 350px;
  margin: 10px;
  transition: all 0.3s 0s linear;
  cursor: pointer;

  .subjectTableBox {
    padding: 5px;
    overflow-x: hidden;
    overflow-y: auto;
    height: 250px;
  }

  .subjectHead {
    position: relative;

    .subjectHeadTitle {
      display: flex;
      flex-wrap: nowrap;

      img {
        width: 60px;
        height: 60px;
      }

      * {
        margin: 10px;
      }

      .el-button {
        border: 1px solid #66B1FF;
        color: #66B1FF;
      }
    }
  }

  .removeBox {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 80px;
    background: #f56c6c;
    line-height: 100px;
    margin: 0 auto;
    text-align: center;
    color: white;
    transition: all 0.3s 0s linear;
    // transform: translateX(100px) translateY(-100px) rotate(45deg);
    transform: translateX(40px) translateY(-40px) rotate(45deg);

    i {
      font-size: 20px;
      transform: rotate(-45deg) translateY(13px) translateX(-8px);
    }
  }

  .removeBox:hover {
    box-shadow: 0 2px 12px 0 #f56c6c;
  }
}

.subjectInfo:hover {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  // .removeBox {
  //   transform: translateX(40px) translateY(-40px) rotate(45deg);
  // }
}

// .subjectInfo::before{
//     content: ''; /* 用伪元素来生成一个矩形 */
//     color: white;
//  position: relative;
//  width: 20px;
//  height: 20px;
//  top: 0; right: 0; bottom: 0; left: 0;
//  background: #f56c6c;
//  transform: skew(45deg);
// }
</style>
